import styled from 'styled-components';
import { Flex, FlexColumn } from '../Flex';

export const PageWrapper = styled.div`
  padding-top: 40px;
  position: absolute;
  left: calc(133px + 50% - 355px);
  .searchResult {
    height: 30px;
    border-left: 2px solid transparent;
    padding: 4px 10px 4px 24px;
    font-size: 14px;
    font-weight: 500;
  }
  .searchResult:hover {
    background: var(--search-text-color-hover);
    background: #eaf2ff;
    border-left: 2px solid var(--search-result-border-hover);
  }
  .stockIcon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    margin-top: 2px;
    border-radius: 50%;
  }
  .fallbackImage {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
    color: white;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    margin-top: 2px;
    border-radius: 50%;
  }
`;

export const SearchTabsWrapper = styled(Flex)`
  max-width: 100%;
  padding: 0 24px 12px;
  border-top: 1px solid var(--color-border) !important;
  .MuiBox-root {
    border-bottom: 0px solid black !important;
  }
  .MuiTabs-root {
    margin: 5px 0 0 0;
    width: 100%;
    border-bottom: 0px solid black !important;
  }
  .MuiTabScrollButton-root {
    max-width: 18px;
    min-width: 18px !important;
    color: var(--search-text-color) !important;
    :hover {
      color: var(--search-text-color-hover) !important;
    }
    border-bottom: 0px solid black !important;
  }
  .MuiTab-root {
    min-width: 50px !important;
    font-family: Montserrat, sans-serif;
    font-size: 15px;
    font-weight: 500;
    text-transform: none !important;
    border-bottom: 0px solid black !important;
    color: var(--search-text-color);
  }
  .MuiTab-root:hover {
    color: var(--search-text-color-hover);
  }
  .MuiTabs-scroller {
    border-bottom: 1px solid;
    border-color: var(--search-border-color-scroller);
  }
  .MuiTabs-indicator {
    background-color: var(--search-background-color-indicator) !important;
  }
  .Mui-disabled {
    width: 0 !important;
    min-width: 0 !important;
  }
  .Mui-selected {
    color: var(--search-text-color-active) !important;
  }
`;

export const Background = styled.div`
  position: fixed;
  z-index: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
`;

export const SearchResults = styled(FlexColumn)<{ $iswide?: number; height: number }>`
  position: absolute;
  width: 711px;
  min-height: ${({ height }) => height || 528}px;
  max-height: ${({ height }) => height || 528}px;
  top: 0px;
  left: 12px;
  padding-top: 36px;
  background: var(--page-background);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
  border-radius: 20px;
  z-index: 2;
  height: fit-content;
`;

export const SearchBlock = styled(FlexColumn)<{ $iswide?: number }>`
  position: relative;
  align-items: center;
  width: 100%;
  max-height: 470px;
  padding: 0;
  overflow-y: auto;
`;

export const NoSearchResults = styled('div')<{ $visible: boolean }>`
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-top: 12px;
  padding-top: 10px;
  margin-left: 24px;
  color: var(--search-text-color);
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};
`;
